export default "__VITE_ASSET__CRWk0fxP__"